var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMundo = function SvgMundo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "mundo_svg__Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 200 43.16"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mundo_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h200v43.16H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".mundo_svg__cls-5{stroke-width:0;fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#mundo_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "mundo_svg__Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_37",
    d: "M188.45 26.83c0 8.75-7.08 15.85-15.84 15.85-8.75 0-15.85-7.08-15.85-15.83S163.84 11 172.6 11h.01c8.75 0 15.84 7.09 15.84 15.83",
    "data-name": "Trazado 37",
    style: {
      fill: "#ffd900",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_38",
    d: "M181.92 5.22c0 2.3-1.86 4.16-4.16 4.16s-4.16-1.86-4.16-4.16 1.86-4.16 4.16-4.16 4.16 1.86 4.16 4.16",
    "data-name": "Trazado 38",
    style: {
      strokeWidth: 0,
      fill: "#ee7b25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_39",
    d: "M200 12.93c0 2.78-2.25 5.03-5.03 5.03s-5.03-2.25-5.03-5.03 2.25-5.03 5.03-5.03c2.78 0 5.03 2.25 5.03 5.03",
    "data-name": "Trazado 39",
    style: {
      fill: "#e63337",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_40",
    d: "M188.45 2.61a2.614 2.614 0 1 1-5.23-.01c0-1.44 1.17-2.61 2.61-2.61s2.61 1.17 2.61 2.62",
    "data-name": "Trazado 40",
    style: {
      fill: "#e73583",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_41",
    d: "M188.45 10.99c0 1.44-1.17 2.62-2.61 2.62s-2.61-1.17-2.61-2.62 1.17-2.61 2.61-2.61 2.61 1.17 2.61 2.61",
    "data-name": "Trazado 41",
    style: {
      fill: "#a81e81",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_42",
    d: "M197.04 22.93c0 1.87-1.51 3.38-3.38 3.38s-3.38-1.51-3.38-3.38 1.51-3.38 3.38-3.38 3.38 1.51 3.38 3.38",
    "data-name": "Trazado 42",
    style: {
      fill: "#00a9e7",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_43",
    d: "M172.6 10.51c-9.02 0-16.33 7.31-16.33 16.33s7.31 16.33 16.33 16.33 16.33-7.31 16.33-16.33-7.31-16.33-16.33-16.33m0 26.11c-5.4 0-9.78-4.38-9.77-9.78 0-5.4 4.38-9.78 9.78-9.77 5.4 0 9.77 4.38 9.77 9.77 0 5.4-4.38 9.78-9.78 9.78",
    className: "mundo_svg__cls-5",
    "data-name": "Trazado 43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_44",
    d: "M131.8 11.21c-2.45 0-6.92 2.87-7.01 6.65v24.55h11.93c4.41.15 8.7-1.43 11.97-4.39 3.02-2.92 4.7-6.96 4.65-11.16v-.09c0-9.04-6.99-15.55-16.62-15.55h-4.92Zm14.28 15.72c0 5.43-3.77 9.07-9.36 9.07h-4.92V17.7h4.92c5.6 0 9.36 3.68 9.36 9.15v.08Z",
    className: "mundo_svg__cls-5",
    "data-name": "Trazado 44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_45",
    d: "M46.9 11.24c-4.13-.04-8 1.98-10.32 5.39a9.735 9.735 0 0 0-9.16-5.39c-4.69 0-7.36 2.56-9.33 5.28V12.3c-.03-.72-.7-1.05-1.47-.8-2.47.8-5.55 3.34-5.55 6.49v24.42h7.01v-17.2c0-4.7 2.66-7.6 6.55-7.6s6.21 2.67 6.21 7.43v17.37h7.02v-17.2c0-4.93 2.72-7.6 6.54-7.6s6.21 2.61 6.21 7.48v17.32h7.02V22.94c0-7.48-4.06-11.71-10.73-11.71",
    className: "mundo_svg__cls-5",
    "data-name": "Trazado 45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_46",
    d: "M87.76 11.48c-2.46.76-5.57 3.26-5.62 6.41v11.23c0 4.75-2.84 7.54-6.9 7.54s-6.55-2.67-6.55-7.42V12.27c-.04-.7-.69-1.03-1.45-.79-2.47.79-5.57 3.33-5.57 6.5v13.34c0 7.14 4 11.78 10.9 11.78 4.76 0 7.6-2.5 9.57-5.4v4.72h7.08V12.31c-.02-.73-.69-1.07-1.45-.83",
    className: "mundo_svg__cls-5",
    "data-name": "Trazado 46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "mundo_svg__Trazado_47",
    d: "M109.84 11.21c6.9 0 10.9 4.64 10.9 11.72V42.4h-7.02V25.07c0-4.76-2.38-7.48-6.55-7.48s-6.9 2.84-6.9 7.6v17.23h-7.02V17.99c0-3.17 3.1-5.72 5.57-6.51.77-.23 1.44.11 1.44.85v4.21c1.97-2.84 4.81-5.33 9.57-5.33",
    className: "mundo_svg__cls-5",
    "data-name": "Trazado 47"
  })))));
};
export default SvgMundo;